import * as React from "react"
import { useSignal } from "@preact/signals-react";
import {Box, Divider, Typography} from "@mui/material"
import {AmchartSeeker, ButtonIconSeeker, ImageSeeker, ModalSeeker, TextFieldSeeker} from "@ui-seeker/core"
import {isEmpty, postSubmit} from "@ui-seeker/utils";
import {useAppToast} from "@ui-seeker/app";

import {ActionButton, ImageSkuBlock} from "@components";
import {WEBBACK_V2_API} from "@constants";
import { monitoringResultsReportIssueData } from "./@signals";



export default function MonitoringResultsIssueModal() {
    const { showToast } = useAppToast()
    const textField = useSignal("")

    if (isEmpty(monitoringResultsReportIssueData.value))
        return <></>

    return <ModalSeeker
        hideActions
        id="evolution-details-chart1"
        isOpen={!isEmpty(monitoringResultsReportIssueData.value)}
        title={'Notify Matching error'}
        controller={() => monitoringResultsReportIssueData.value = {}}
        sx={{ width: 80}}
    >
        <Box display="flex" flexDirection="column" justifyContent="center" alignItems="center">
            <Typography variant='subtitle1'>Site</Typography>
            <Divider sx={{ bgcolor: 'primary.light', fontWeight: 'bold'}} />

            <Box display="flex" alignItems="center">
                <ImageSeeker
                    src={`/logos/website_ico_${monitoringResultsReportIssueData.value.siteID}.png`}
                    width={16}
                    height={16}
                    alt={monitoringResultsReportIssueData.value.retailer}
                />
                <Typography sx={{ ml: 0.5, mb: 1 }}>{monitoringResultsReportIssueData.value.retailer}</Typography>
            </Box>

            <Typography variant='subtitle1'>Sku</Typography>
            <Divider sx={{ bgcolor: 'primary.light', fontWeight: 'bold'}} />

            <Typography sx={{ mb: 0.5 }}>{monitoringResultsReportIssueData.value.sku}</Typography>
            <ImageSkuBlock
                skuID={monitoringResultsReportIssueData.value.skuID}
                alt={monitoringResultsReportIssueData.value.sku}
                imageProps={{sx: { height: 120 } }}
            />

            <TextFieldSeeker
                label={"If you know the correct URL for this SKU, please enter it here."}
                value={textField.value}
                onChange={e => textField.value = e.target.value}
                sx={{width: 480, mt: 2}}
            />

            <ActionButton
                label="Report Issue"
                icon="paper-plane"
                sx={{ mt: 3 }}
                onClick={() =>
                    showToast.promise(
                        // Close only on success: on failure the modal keeps the URL so the user can
                        // retry without typing it again.
                        postSubmit(`${WEBBACK_V2_API}/monitoring/results/matching_error`, {
                            retailer: monitoringResultsReportIssueData.value.retailer,
                            sku: monitoringResultsReportIssueData.value.sku,
                            skuID: monitoringResultsReportIssueData.value.skuID,
                            siteID: monitoringResultsReportIssueData.value.siteID,
                            correctURL: textField.value
                        })
                        .then(res => {
                            monitoringResultsReportIssueData.value = {}
                            textField.value = ''
                            return res
                        }),
                        {
                            pending: 'Sending the matching error...',
                            error: 'The matching error could not be sent. Please try again in a few seconds.',
                            success: 'Matching error successfully notified.',
                        }
                    )
                    // The rejection is already reported by the toast above; caught here only to
                    // avoid an unhandled rejection.
                    .catch(() => {})
                }
            />
        </Box>
    </ModalSeeker>
}